/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable camelcase */
import PropTypes from 'prop-types';
import MediaQuery from 'react-responsive';

import {
  VolumeUnit,
  HighUnit,
  LowUnit,
  StrikePrice,
  // dateFormat,
  NextFunding,
  SettlementUnit,
  MaturityUnit,
  NextFundingTicker,
  EstimatedFundingUnit,
  FundingUnit,
  KnockoutPriceUnit,
  Ticker24hrChangePercent,
  OiUnit,
  // CombosLegsStrikePrices,
} from 'components/Header/partials/tickerUnit';
import { device } from 'helpers/screenSizes';
import { isTurbo } from 'helpers/utils';
import { ContractType } from 'types/IProducts';

import ThreeDotsMenu from '../partials/ThreeDotsMenu';
import styles from './index.module.scss';

const Desktop24hrHeader = ({ selectedProduct }) => {
  const { contract_type } = selectedProduct;

  const showSettlementUnit =
    contract_type === ContractType.CallOptions ||
    contract_type === ContractType.PutOptions ||
    contract_type === ContractType.MoveOptions ||
    contract_type === ContractType.Spreads ||
    contract_type === ContractType.OptionsCombos ||
    contract_type === ContractType.Futures;

  const showStrikePrice = contract_type === ContractType.MoveOptions;

  // const showLegs = contract_type === ContractType.OptionsCombos;
  const showKnockOutPrice = isTurbo(contract_type);
  const isIrs = contract_type === 'interest_rate_swaps';
  const showOi =
    contract_type !== ContractType.Spot && contract_type !== ContractType.Tracker;
  const showHighLow =
    contract_type === ContractType.Spot ||
    contract_type === ContractType.Tracker ||
    contract_type === ContractType.PerpetualFutures;

  return (
    (<div
      className={styles['header-change-container']}
      data-palette="Desktop24hrHeader">
      <Ticker24hrChangePercent contract_type={contract_type} />
      <VolumeUnit product={selectedProduct} />
      {showOi && <OiUnit product={selectedProduct} />}
      {showStrikePrice ? <StrikePrice product={selectedProduct} /> : null}
      {/* {showLegs ? <CombosLegsStrikePrices product={selectedProduct} /> : null} */}
      {showSettlementUnit ? <SettlementUnit product={selectedProduct} /> : null}
      {showKnockOutPrice ? <KnockoutPriceUnit product={selectedProduct} /> : null}
      {isIrs ? <NextFunding product={selectedProduct} /> : null}
      {isIrs ? <MaturityUnit product={selectedProduct} /> : null}
      {contract_type === 'perpetual_futures' ? (
        <FundingUnit product={selectedProduct} />
      ) : null}
      {contract_type === 'perpetual_futures' ? (
        <EstimatedFundingUnit product={selectedProduct} />
      ) : null}
      <MediaQuery query={device.down.lg}>
        {contract_type === 'perpetual_futures' && (
          <ThreeDotsMenu product={selectedProduct} />
        )}
        {contract_type === ContractType.Tracker && <HighUnit product={selectedProduct} />}
        {contract_type === ContractType.Tracker && <LowUnit product={selectedProduct} />}
      </MediaQuery>
      <MediaQuery query={device.up.lg}>
        {contract_type === 'perpetual_futures' ? (
          <NextFundingTicker product={selectedProduct} />
        ) : null}
        {showHighLow && <HighUnit product={selectedProduct} />}
        {showHighLow && <LowUnit product={selectedProduct} />}
      </MediaQuery>
    </div>)
  );
};

Desktop24hrHeader.propTypes = {
  selectedProduct: PropTypes.shape({
    contract_type: PropTypes.string,
  }),
};

export default Desktop24hrHeader;
